import React, {useState} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {connect} from 'react-redux';
import {create_supplier} from '../../redux/actions/adminActions';
import {Modal} from 'react-bootstrap';
import ProfileEdit from '../admin/suppliers/profileEdit';
import LicenseCapture from '../admin/suppliers/licenseCapture';
import NextOfKin from '../admin/suppliers/nextOfKin';
import ResetPassword from '../admin/suppliers/resetPassword';

function CreateSupplierModal({show, handleClose, createSupplier, accessToken}) {

    const [newUser,
        setNew] = useState({});

    const [index,
        setIndex] = useState(0);

    const handleInputChange = (input) => {
        let body = {
            ...newUser,
            ...input
        };
        setNew(body);
        handleCreate(body);
    }

    const handleCreate = (data) => {

        let formdata = new FormData();

        formdata.append("business_name", data
            ?.business_name);
        formdata.append("manager_name", data
            ?.manager_name);
        formdata.append("business_address", data
            ?.business_address);
        formdata.append("email_address", data
            ?.email_address);
        formdata.append("phone_number", data
            ?.phone_number);
        formdata.append("divers_licence", data
            ?.sent_drivers_licence);
        formdata.append("photograph", data
            ?.sentPhoto);
        formdata.append("bank_name", data
            ?.bank_name);
        formdata.append("account_number", data
            ?.account_number);
        formdata.append("account_name", data
            ?.account_name);
        formdata.append("shop_coordinates", data
            ?.shop_coordinates);
        formdata.append("next_of_kin_name", data
            ?.next_of_kin_name);
        formdata.append("next_of_kin_phone", data
            ?.next_of_kin_phone);
        formdata.append("next_of_kin_address", data
            ?.next_of_kin_address);
        formdata.append("password", data
            ?.password);
        formdata.append("password_confirmation", data
            ?.password_confirmation);

        createSupplier(formdata, accessToken, () => {
            setIndex(0);
            // handleClose();
        });
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>

            <div className="suppliers py-4">
                <Tabs selectedIndex={index}>
                    <TabList className='alignOnly sectionText pl-0 p-2 mb-0'>
                        <Tab className='tabHead'>Profile</Tab>
                        <Tab className='tabHead'>Driver’s License/Passport</Tab>
                        <Tab className='tabHead'>Next of Kin</Tab>
                        <Tab className='tabHead'>Password</Tab>
                    </TabList>

                    <TabPanel>
                        <ProfileEdit
                            newUser
                            submit={(data) => setNew({
                            ...newUser,
                            ...data
                        })}
                            next={() => setIndex(index + 1)}/>
                    </TabPanel>
                    <TabPanel>
                        <LicenseCapture
                            submit={(data) => setNew({
                            ...newUser,
                            ...data
                        })}
                            prev={() => setIndex(index - 1)}
                            next={() => setIndex(index + 1)}
                            newUser/>
                    </TabPanel>
                    <TabPanel>
                        <NextOfKin
                            newUser
                            submit={(data) => setNew({
                            ...newUser,
                            ...data
                        })}
                            next={() => setIndex(index + 1)}/>
                    </TabPanel>
                    <TabPanel>
                        <ResetPassword newUser submit={(input) => handleInputChange(input)}/>
                    </TabPanel>
                </Tabs>
            </div>
        </Modal>

    )
}

const mapStateToProps = (state) => ({accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    createSupplier: (data, token, success) => dispatch(create_supplier(data, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateSupplierModal)
